import {
    Card,
    CardContent,
    Grid2,
    Typography
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { PaperTableHeader } from '../../_components/table/header.table';
import { TABLE_FILTER } from '../../_const/tableFilter.const';
import { handleErrorResponse } from '../../_helpers/handleResponse.helper';
import { newsService } from '../../_services/news.service';
import { NewsManageDrawer } from '../news/news-manageDrawer';
import { getDate, getDateString } from '../../_helpers/dateTime.helper';
import { NewsFileTypeEnum } from '../../_common/enum/newsFileType.enum';
import { NewsStatusEnum } from '../../_common/enum/newsStatus.enum';
export function NewsfeedIndex() {
    const [data, setData] = useState<any>({ items: [] });
    const [filter, setFilter] = useState<any>({ ...TABLE_FILTER, orderBy: "createdDate", order: "desc", pageSize: 20, newsStatusId: NewsStatusEnum.Approved });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        setIsLoading(true);
        return await newsService.getAll(filter)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [filter]);

    return (
        <>

            <PaperTableHeader title="News Feed" buttons={[
                { icon: "add", label: "Create", onClick: () => { navigate("Newsfeed/Create") } }
            ]} />

            <Grid2 container spacing={1} sx={{ "padding": "8px" }}>
                {data.items.map((item: any) => (
                    <Grid2 size={{ xs: 12 }}>
                        <Card key={item.id} sx={{ minHeight:"300px" }}>
                            <CardContent>
                                <Typography variant="h6" sx={{ display: 'flex', justifyContent: 'space-between', }}>
                                    <span>{item.createdBy}</span>
                                    <span>{item.centreName}</span>
                                </Typography>
                                <Typography variant="body1" sx={{ display: 'flex', justifyContent: 'space-between', mt: 2, }}>
                                    <span>{getDate(item.createdDate)}</span>
                                    <span>{item.newsCategoryName}</span>
                                </Typography>
                                <div dangerouslySetInnerHTML={{ __html: item.description }}></div>

                                <Grid2 sx={{ mt: 1 }}>
                                    {item.newsFiles.map((item: any) => (
                                        item.newsFileTypeId === NewsFileTypeEnum.Document && (
                                            <Grid2>
                                                <a href={item.fileUrl}
                                                    target="_blank">
                                                    {item.fileName}
                                                </a>
                                            </Grid2>)
                                    ))}
                                </Grid2>
                                <Grid2 container spacing={2} sx={{ mt: 2, justifyContent: "center" }}>
                                    {item.newsFiles.map((item: any) => (
                                        item.newsFileTypeId === NewsFileTypeEnum.Image && (
                                            <Grid2>
                                                <img
                                                    src={item.fileUrl}
                                                    alt={item.fileName}
                                                    style={{
                                                        maxWidth: "100%",
                                                        maxHeight: "100%",
                                                        borderRadius: 8,
                                                    }}
                                                />
                                            </Grid2>)
                                    ))}
                                </Grid2>
                            </CardContent>
                        </Card>
                    </Grid2>
                ))}
            </Grid2>
            <Routes>
                <Route path="Newsfeed/Create" element={<NewsManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
            </Routes>
        </>
    );
}
